import React from "react";

const ClearLabel = ({ onClick }) => (
  <div onClick={onClick} className="clear-label">
    (clear)
  </div>
);

export default ClearLabel;
